import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme ,ThemeProvider} from '@material-ui/core/styles';
import './index.css';
// import AppLayout from './components/AppLayout';
import Routes from './Routes';
import {THEME_SECONDARY_COLOR, THEME_PRIMARY_COLOR} from './Constants';
import * as serviceWorker from './serviceWorker';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: THEME_PRIMARY_COLOR  //'#428bfe'
    },
    secondary: {
      main: THEME_SECONDARY_COLOR
    }
  },
  typography: {
    fontFamily: '"Source Sans Pro" ,"Titillium Web", sans-serif',
  },
});

ReactDOM.render(<ThemeProvider theme={theme}>
  <Routes />
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
